var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":"Cidade","placeholder":"Cidade","hide-details":""},on:{"change":_vm.onChange},model:{value:(_vm.cidadeComplemento),callback:function ($$v) {_vm.cidadeComplemento=$$v},expression:"cidadeComplemento"}})}
var staticRenderFns = []

export { render, staticRenderFns }